export const baseI18nSetRouteMeta = (data: any) => {
  if (!data) { return }

  const nuxtApp = useNuxtApp()
  const { locales } = nuxtApp.$i18n

  const localeCodeForIso = (iso) => {
    return locales.value?.find(i => i.iso === iso)?.code
  }

  // 1. initialize i18nMetaObject with active locale
  const i18nMetaObject = {
    [baseI18nGetActiveCode()]: { slug: baseStrapiGetAttributes(data)?.slug }
  }

  // 2. add other locales from data
  const localizations = baseStrapiGetAttributes(data)?.localizations?.data || null

  if (!localizations) { return }

  localizations?.forEach((i: any) => {
    i18nMetaObject[localeCodeForIso(i?.attributes?.locale)] = { slug: i?.attributes?.slug }
  })

  // 3. add missing locales from i18n.locales and set slug to empty string
  const languageCodes = locales?.value?.map(i => i?.code)
  const hasAllLanguageCodes = languageCodes.every(i =>
    Object.prototype.hasOwnProperty.call(i18nMetaObject, i)
  )
  if (!hasAllLanguageCodes) {
    const missingLanguageCodes = languageCodes?.map(languageCode => Object.prototype.hasOwnProperty.call(i18nMetaObject, languageCode) ? null : languageCode)?.filter(i => i !== null)
    missingLanguageCodes?.forEach((i: any) => {
      i18nMetaObject[i] = { slug: '' }
    })
  }

  // 4. set route.meta.nuxtI18n
  const route = useRoute()
  if (i18nMetaObject) {
    const defaults = route.meta.nuxtI18n ? route.meta.nuxtI18n : {}
    route.meta.nuxtI18n = { ...defaults, ...i18nMetaObject }
  }

  // 5. set title
  if (baseStrapiGetAttributes(data)?.title) {
    route.meta.title = baseStrapiGetAttributes(data)?.title
  }
}
